import axios from '@axios'
// import { getMainOffice } from '~/shared/utils'

export default {
  state: {
    applicationInfo: {},
    selectedBranch: {},
    branches: [],
    colors: {},
    newLogo: null,
    applicationStatus: {},
  },
  getters: {
    getApplicationInfo(state) {
      return state.applicationInfo
    },
    getBranches(state) {
      return state.branches
    },
    hasBranches(state) {
      return Object.values(state.branches).reduce((total, orgs) => total + orgs.length, 0) > 1
    },
    getColors(state) {
      return state.colors
    },
    getSelectedBranch(state) {
      return state.selectedBranch
    },
    getNewLogo(state) {
      return state.newLogo
    },
    getApplicationStatus(state) {
      return state.applicationStatus
    }
  },
  mutations: {
    SET_APPLICATION_INFO(state, data) {
      state.applicationInfo = data
    },
    SET_BRANCHES(state, data) {
      state.branches = data
    },
    SET_COLORS(state, data) {
      state.colors = data
    },
    // SET_AND_CHECK_SELECTED_BRANCH(state, data) {
    //   state.selectedBranch = getMainOffice(data.offices_by_city)
    // },
    SET_NEW_LOGO(state, data) {
      state.newLogo = data
    },
    SET_APP_SETTINGS(state, data) {
      state.applicationInfo.mobile_settings.background_image_url = data.background_image_url
      state.applicationInfo.mobile_settings.icon_url = data.icon_url
    },
    SET_APP_STATUS(state, data) {
      state.applicationStatus = data
    }
  },
  actions: {
    fetchApplicationInfo(context, organizationId) {
      return new Promise((resolve, reject) => {
        axios.get(`/organizations/mobile-client-app/${organizationId}`)
          .then(response => {
            context.commit('SET_COLORS', response.data.main_office.mobile_settings.colors)
            context.commit('SET_BRANCHES', response.data.offices_by_city)
            // context.commit('SET_AND_CHECK_SELECTED_BRANCH', response.data)
            context.commit('SET_APPLICATION_INFO', response.data.main_office)
            resolve(response)
          })
          .catch(error => reject(error))
      })
    },
    updateApplicationInfo(context, data) {
      return new Promise((resolve, reject) => {
        console.log('updateApplicationInfo', data)
        axios.patch(`/organizations/mobile-client-app/update/${data.organization_id}`, data)
          .then(response => {
            context.commit('SET_APP_SETTINGS', response.data)
            resolve(response)
          })
          .catch(error => reject(error))
      })
    },
    checkApplicationStatus(context, org) {
      return new Promise((resolve, reject) => {
        axios.get(`/organizations/mobile-client-app/status/${org}`)
          .then(response => {
            context.commit('SET_APP_STATUS', response.data)
            resolve(response)
          })
          .catch(error => reject(error))
      })
    },
  },
}
